import {
  SR_API_ERROR_NOT_ALLOWED,
  SR_API_ERROR_REQUEST_INVALID_RESPONSE,
  SR_API_ERROR_REQUEST_FAILED,
  SR_API_ERROR_REQUEST_NOT_HANDLED_OK,
  SR_API_ERROR_ACTION_PAYLOAD_VALIDATION_FAILED,
} from 'common/errorCodes';

const allowedMessages = ['Provider already exists'];

const DEFAULT_USER_ERROR_MESSAGE =
  "Oops! It seems like there's a problem. We apologize for the trouble.";

const handleUserErrorMessages = ({ error, shortId }) => {
  const defaultErrorMessageWithId = `${DEFAULT_USER_ERROR_MESSAGE} Please share this code with Support: ${shortId}`;

  for (const allowedMessage of allowedMessages) {
    if (error.message.includes(allowedMessage)) {
      return error.message;
    }
  }

  // Message was handled previously.
  if (String(error.name).toLowerCase() !== 'error') {
    // Evaluate errors that require a error.message
    // update to be more user friendly.
    switch (error.name) {
      case SR_API_ERROR_NOT_ALLOWED:
        if (error.message.includes('Request session roles')) {
          return defaultErrorMessageWithId;
        }
        return error.message;
      case SR_API_ERROR_ACTION_PAYLOAD_VALIDATION_FAILED:
        if (error.message.includes('Payload validation failed')) {
          return defaultErrorMessageWithId;
        }
        return error.message;
      case SR_API_ERROR_REQUEST_INVALID_RESPONSE:
      case SR_API_ERROR_REQUEST_FAILED:
      case SR_API_ERROR_REQUEST_NOT_HANDLED_OK:
        return defaultErrorMessageWithId;
      default:
        // Keep the error message as it is since
        // it has been managed by other methods.
        return error.message;
    }
  }
  // Set default error message.
  return defaultErrorMessageWithId;
};

export default handleUserErrorMessages;
